import { useState } from "react";
import { setGoingToClose, setHasToRefresh } from "../../redux/rightModalSlice";
import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import Loader from "../Loader";

export default function DeleteAgentConfirmation({ agentId, agentName }) {
    const dispatch = useDispatch();
    const token = localStorage.getItem('installamelo-auth-token') ?? '';
    const [deleteStatus, setDeleteStatus] = useState('initial'); // 'initial', 'loading', 'success', 'error'
    const [errorMessage, setErrorMessage] = useState('');

    const handleDeleteAgent = async () => {
        setDeleteStatus('loading');

        try {
            const url = `${import.meta.env.VITE_API_BASE_URL}/agents/${agentId}`;
            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Errore durante l'eliminazione dell'agente");
            }

            setDeleteStatus('success');
            dispatch(setHasToRefresh());

            setTimeout(() => {
                dispatch(setGoingToClose());
            }, 1500);

        } catch (error) {
            console.error("Errore durante l'eliminazione dell'agente:", error);
            setErrorMessage(error.message || "Errore durante l'eliminazione dell'agente");
            setDeleteStatus('error');
        }
    };

    return (
        <div className="w-full p-8">
            <div className="flex flex-col gap-6 mt-8 border-2 rounded-lg p-6 border-red-200 relative">
                <h1 className="text-2xl font-bold">Elimina Agente</h1>

                {deleteStatus === 'initial' && (
                    <>
                        <div className="flex items-center justify-center p-6 bg-red-50 rounded-lg">
                            <div className="text-center">
                                <div className="text-red-500 text-5xl mb-4">
                                    <DynamicIcon iconClass="fa-solid fa-triangle-exclamation" />
                                </div>
                                <p className="text-lg mb-2">Sei sicuro di voler eliminare l'agente:</p>
                                <p className="text-xl font-semibold mb-4">{agentName}</p>
                                <p className="text-sm text-gray-600 mb-4">Questa azione non può essere annullata. Tutte le credenziali dell'agente verranno invalidate.</p>
                            </div>
                        </div>

                        <div className="flex gap-4 justify-center">
                            <button
                                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center gap-2"
                                onClick={handleDeleteAgent}
                            >
                                <DynamicIcon iconClass="fa-solid fa-trash" />
                                Elimina
                            </button>
                            <button
                                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                                onClick={() => dispatch(setGoingToClose())}
                            >
                                Annulla
                            </button>
                        </div>
                    </>
                )}

                {deleteStatus === 'loading' && (
                    <div className="flex justify-center items-center p-8">
                        <Loader />
                    </div>
                )}

                {deleteStatus === 'success' && (
                    <div className="flex flex-col items-center justify-center p-6 bg-green-50 rounded-lg">
                        <div className="text-green-500 text-5xl mb-4">
                            <DynamicIcon iconClass="fa-solid fa-circle-check" />
                        </div>
                        <p className="text-lg">Agente eliminato con successo!</p>
                    </div>
                )}

                {deleteStatus === 'error' && (
                    <>
                        <div className="flex flex-col items-center justify-center p-6 bg-red-50 rounded-lg">
                            <div className="text-red-500 text-5xl mb-4">
                                <DynamicIcon iconClass="fa-solid fa-circle-xmark" />
                            </div>
                            <p className="text-lg mb-2">Si è verificato un errore durante l'eliminazione:</p>
                            <p className="text-sm text-red-600">{errorMessage}</p>
                        </div>

                        <div className="flex gap-4 justify-center">
                            <button
                                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center gap-2"
                                onClick={handleDeleteAgent}
                            >
                                Riprova
                            </button>
                            <button
                                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                                onClick={() => dispatch(setGoingToClose())}
                            >
                                Annulla
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
